import { useBeeswaxAccountAudienceList } from "@/modules/Audience/AccountAudience/AccountAudience.hook";
import { useEmailAudience } from "@/modules/Audience/EmailAudience/emailAudience.hook";
import { useSiteVistorAudienceList } from "@/modules/Audience/SiteVisitorAudience/siteVisitorAudience.hook";
import { AUDIENCE_TYPES } from "@/modules/Campaign/campaign.constant";

export function useCustomSegmentData({
  isEdit,
  advertiserId,
}: {
  isEdit: boolean;
  advertiserId?: number
}) {
  const isEnabled = Boolean(advertiserId)
  const accountAudience = useBeeswaxAccountAudienceList({
    enabled: isEnabled,
    queryParams: {
      advertiserId,
      status: JSON.stringify(["completed", "processing"]),
    },
  });
  const emailAudience =
    useEmailAudience({
      enabled: isEnabled,
      queryParams: {
        advertiserId,
        status: JSON.stringify(["completed", "processing"]),
      },
    });
  const siteVisiterAudience = useSiteVistorAudienceList({
    enabled: isEnabled,
    advertiserId,
    status: JSON.stringify(["completed", "processing"]),
  });

  return {
    audiences: {
      [AUDIENCE_TYPES.Audience]: accountAudience,
      [AUDIENCE_TYPES.EmailAudiences]: emailAudience,
      [AUDIENCE_TYPES.RetargetAudience]: siteVisiterAudience
    }
  };
}
